// Shared helpers for the Tag Workspace (metriqs.co.in).
import { buildTagDataFromDetail, tagMaterials } from '@/components/jewellery/JewelleryTagViewer';


export function initialsOf(nameOrEmail) {
  const s = (nameOrEmail || '').trim();
  if (!s) return '?';
  const parts = s.split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return s.slice(0, 2).toUpperCase();
}

// Derive diamond / colour-stone / pearl carats + pieces for a card.
// Prefers the precomputed `components` (inventique-origin pieces); falls back to
// summing the manual-tag `rm_consumed_snapshot` rows by material type.
export function deriveStones(item) {
  const c = item && item.components;
  if (c && (c.diamond_carats || c.color_stone_carats || c.pearl_carats
    || c.diamond_pieces || c.color_stone_pieces || c.pearl_pieces)) {
    return {
      dCt: Number(c.diamond_carats || 0), dPcs: Number(c.diamond_pieces || 0),
      csCt: Number(c.color_stone_carats || 0), csPcs: Number(c.color_stone_pieces || 0),
      pCt: Number(c.pearl_carats || 0), pPcs: Number(c.pearl_pieces || 0),
    };
  }
  const snap = Array.isArray(item && item.rm_consumed_snapshot) ? item.rm_consumed_snapshot : [];
  const acc = { dCt: 0, dPcs: 0, csCt: 0, csPcs: 0, pCt: 0, pPcs: 0 };
  for (const r of snap) {
    const t = (r.material_type || '').toLowerCase();
    const ct = Number(r.carats || 0);
    const pcs = Number(r.pieces || 0);
    if (t === 'diamond') { acc.dCt += ct; acc.dPcs += pcs; }
    else if (t === 'color_stone' || t === 'colour_stone' || t === 'colorstone') { acc.csCt += ct; acc.csPcs += pcs; }
    else if (t === 'pearl') { acc.pCt += ct; acc.pPcs += pcs; }
  }
  return acc;
}

// Net and visible lines exactly as the tag prints them (cached per card object).
const _fig = new WeakMap();
export function tagFigures(item) {
  if (!item) return { net: 0, lines: [] };
  let f = _fig.get(item);
  if (!f) { const d = buildTagDataFromDetail(item); f = { net: Number(d.net || 0), lines: tagMaterials(d, 'expanded') }; _fig.set(item, f); }
  return f;
}


// Category totals from the tag's visible lines (buildTagDataFromDetail(...).materials).
export function stonesOfLines(lines) {
  const acc = { dCt: 0, dPcs: 0, csCt: 0, csPcs: 0, pCt: 0, pPcs: 0 };
  for (const m of lines || []) {
    const t = String(m.materialType || '').toLowerCase();
    const ct = Number(m.carats || 0);
    const pcs = Number(m.pieces || 0);
    if (t === 'diamond') { acc.dCt += ct; acc.dPcs += pcs; }
    else if (t === 'color_stone' || t === 'colour_stone' || t === 'colorstone') { acc.csCt += ct; acc.csPcs += pcs; }
    else if (t === 'pearl') { acc.pCt += ct; acc.pPcs += pcs; }
  }
  return { ...acc, dCt: Math.round(acc.dCt * 100) / 100, csCt: Math.round(acc.csCt * 100) / 100, pCt: Math.round(acc.pCt * 100) / 100 };
}


export function hasAnyStone(s) {
  return (s.dCt || s.csCt || s.pCt || s.dPcs || s.csPcs || s.pPcs) > 0;
}
